<template>
  <div>
    <card-seplag titulo="Formulário de Cadastro">
      <div class="p-col-12 p-grid" style="margin-top: 10px">
        <div style="color: red" class="p-col-12 avisos">
          <label
            >Adicione o bem/valor preenchendo todos os campos do
            formulário.</label
          >
          <label>
            Todos os bens serão listados na tabela abaixo, nesta poderá
            editá-los ou excluí-los.</label
          >
        </div>

        <Rotulo
          nome="Código do Bem"
          requerido
          cols="12 "
          style="display: block; margin: 0"
        >
          <Dropdown
            v-model="registro.tipoBem"
            :options="codigoBem"
            optionLabel="nomeApresentacao"
            :filter="true"
            placeholder="Selecione o código"
            :showClear="true"
            :disabled="true"
          >
            <template #value="slotProps">
              <div v-if="slotProps.value">
                <div
                  v-if="slotProps.value.nomeApresentacao.length > 60"
                  v-tooltip.right="slotProps.value.nomeApresentacao"
                >
                  {{
                    slotProps.value.nomeApresentacao.length > 60
                      ? `${slotProps.value.nomeApresentacao.substring(
                          0,
                          100
                        )} ...`
                      : slotProps.value.nomeApresentacao
                  }}
                </div>
                <div v-else>{{ slotProps.value.nomeApresentacao }}</div>
              </div>

              <span v-else>
                {{ slotProps.placeholder }}
              </span>
            </template>

            <template #option="slotProps">
              <div
                v-if="slotProps.option.nomeApresentacao.length > 60"
                v-tooltip.right="slotProps.option.nomeApresentacao"
              >
                {{
                  slotProps.option.nomeApresentacao.length > 60
                    ? `${slotProps.option.nomeApresentacao.substring(
                        0,
                        100
                      )} ...`
                    : slotProps.option.nomeApresentacao
                }}
              </div>
              <div v-else>{{ slotProps.option.nomeApresentacao }}</div>
            </template>
          </Dropdown>
        </Rotulo>

        <Rotulo
          nome="Localização"
          requerido
          cols="12"
          style="display: block; margin-top: 10px"
        >
          <Dropdown
            v-model="registro.pais"
            :options="localizacao"
            optionLabel="nomePais"
            placeholder="Selecione a localização"
            :filter="true"
            :disabled="true"
          />
        </Rotulo>

        <Rotulo
          nome="Proprietário"
          requerido
          cols="12"
          :vertical="true"
          style="margin-top: 10px"
        >
          <div style="display: flex; justify-content: start">
            <span>
              <strong> Titular </strong>
              <RadioButton
                inputId="tipoDependencia1"
                :name="registro.flagTitularDependente"
                value="T"
                v-model="registro.flagTitularDependente"
                :disabled="true"
              />
            </span>

            <span style="margin-left: 15px">
              <strong> Dependente </strong>
              <RadioButton
                inputId="tipoDependencia2"
                :name="registro.flagTitularDependente"
                value="D"
                v-model="registro.flagTitularDependente"
                :disabled="true"
              />
            </span>
          </div>
        </Rotulo>

        <Rotulo
          nome="Tipo Dependente"
          cols="12"
          style="display: block; margin-top: 10px"
          v-if="registro.flagTitularDependente == 'D'"
        >
          <Dropdown
            v-model="registro.tipoDependente"
            :options="tipoDependencia"
            optionLabel="descricaoTipoDependente"
            placeholder="Selecione o tipo dependente"
            :filter="true"
            :disabled="true"
          >
            <template #value="slotProps">
              <div class="p-dropdown-car-value" v-if="slotProps.value">
                <div
                  v-if="slotProps.value.descricaoTipoDependente.length > 60"
                  v-tooltip.right="slotProps.value.descricaoTipoDependente"
                >
                  {{
                    slotProps.value.descricaoTipoDependente.length > 60
                      ? `${slotProps.value.descricaoTipoDependente.substring(
                          0,
                          100
                        )} ...`
                      : slotProps.value.descricaoTipoDependente
                  }}
                </div>
                <div v-else>{{ slotProps.value.descricaoTipoDependente }}</div>
              </div>
              <span v-else>
                {{ slotProps.placeholder }}
              </span>
            </template>

            <template #option="slotProps">
              <div
                v-if="slotProps.option.descricaoTipoDependente.length > 60"
                v-tooltip.right="slotProps.option.descricaoTipoDependente"
              >
                {{
                  slotProps.option.descricaoTipoDependente.length > 60
                    ? `${slotProps.option.descricaoTipoDependente.substring(
                        0,
                        100
                      )} ...`
                    : slotProps.option.descricaoTipoDependente
                }}
              </div>
              <div v-else>{{ slotProps.option.descricaoTipoDependente }}</div>
            </template>
          </Dropdown>
        </Rotulo>

        <Rotulo
          nome="Discriminação"
          requerido
          cols="12"
          style="margin-top: 10px"
        >
          <Textarea
            v-model="registro.descDiscriminacao"
            :autoResize="true"
            rows="5"
            cols="30"
            @keyup="keyupFn()"
            :disabled="true"
          />
          <div class="contador-caracteres">
            <span>
              {{
                QtdMaximoCaracteres -
                (registro.descDiscriminacao
                  ? registro.descDiscriminacao.length
                  : 0)
              }}
              caracteres restantes</span
            >
          </div>
        </Rotulo>

        <div class="p-col-12">
          <div class="p-grid">
            <Rotulo nome="Valor da Aquisição" requerido cols="12 6">
              <InputNumber
                v-model="registro.valrAquisicao"
                mode="currency"
                currency="BRL"
                locale="pt-BR"
                :disabled="true"
              />
            </Rotulo>

            <Rotulo nome="Valor Venal" requerido cols="12 6">
              <InputNumber
                v-model="registro.valrVenal"
                mode="currency"
                currency="BRL"
                locale="pt-BR"
                :disabled="true"
              />
            </Rotulo>

            <div class="p-md-4" />
          </div>
        </div>

        <div ref="divButtons" class="p-col-12 p-md-3" v-if="isEditando">
          <Button
            label="Fechar Bens"
            class="p-button-raised p-button-rounded"
            @click="limparCampo()"
          />
        </div>
      </div>
    </card-seplag>

    <card-seplag titulo="Tabela de Bens Cadastrados" classe="p-col-12">
      <DataTable
        :value="tabelaBens"
        class="p-datatable-responsive-demo p-datatable-gridlines"
        :paginator="true"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        :rowsPerPageOptions="[10, 20, 50]"
        currentPageReportTemplate="{first} de {last} - {totalRecords} registros"
        :totalRecords="tabelaBens.length"
        :rows="10"
        :lazy="true"
      >
        <Column
          field="numrSeqInclusao"
          header="Item"
          headerStyle="width: 2rem"
          bodyClass="columnAlign"
        />
        <Column
          field="tipoBem.nomeApresentacao"
          header="Cód. do Bem"
          headerStyle="width: 13rem"
          bodyClass="columnAlign"
        />
        <Column
          field="flagTitularDependenteDesc"
          header="Proprietário"
          headerStyle="width: 4rem"
          bodyClass="columnAlign"
        />
        <Column
          field="valrAquisicao"
          header="Valor Aquisição"
          headerStyle="width: 4rem"
          bodyClass="columnAlign"
        >
          <template #body="slotProps">
            {{
              slotProps.data && slotProps.data.valrAquisicao
                ? slotProps.data.valrAquisicao.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })
                : ""
            }}
          </template>
        </Column>
        <Column
          field="valrVenal"
          header="Valor Venal"
          headerStyle="width: 4rem"
          bodyClass="columnAlign"
        >
          <template #body="slotProps">
            {{
              slotProps.data && slotProps.data.valrVenal
                ? slotProps.data.valrVenal.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })
                : ""
            }}
          </template>
        </Column>
        <Column
          field="dataInclusao"
          header="Data de Inclusão do Bem"
          headerStyle="width: 5rem"
          bodyClass="columnAlign"
        />
        <Column headerStyle="width: 4em" bodyClass="columnAlign" header="Ação">
          <template #body="slotProps">
            <Button
              type="button"
              icon="pi pi-eye"
              @click="editarDadosTabelaBens(slotProps.data)"
              class="p-button-raised p-button-warning"
              style="margin-right: 0.5rem"
            />
          </template>
        </Column>
      </DataTable>
    </card-seplag>

    <div class="p-col-12 p-md-4">
      <Button
        label="Voltar"
        icon="pi pi-arrow-left"
        class="p-button-raised p-button-rounded p-button-outlined"
        @click="voltar()"
      />
    </div>
  </div>
</template>

<script>
import CardSeplag from "@/template/CardSeplag.vue";
import Rotulo from "@/template/RotuloSeplag.vue";
import { baseApiUrl } from "@/config/global";

const getDeclaracaoBens = () => {
  return {
    tipoBem: null,
    pais: {
      codgSped: "1058",
      idenPais: 32,
      nomePais: "Brasil",
      siglPais: "BRASIL",
    },
    idenPessoaExercicio: null,
    numrSeqInclusao: null,
    flagTitularDependente: null,
    tipoDependente: null,
    descDiscriminacao: null,
    valrAquisicao: null,
    valrVenal: null,
  };
};

export default {
  name: "declaracaoFormulario",
  components: { CardSeplag, Rotulo },
  props: {
    mode: {
      type: String,
      require: true,
    },
    pFormData: {
      type: Object,
      require: true,
    },
    isPermitirEditar: {
      type: Boolean,
      require: false,
    },
  },
  data: function () {
    return {
      registro: getDeclaracaoBens(),
      tabelaBens: [],
      tipoDependencia: [],
      codigoBem: [],
      localizacao: [],
      camposTabelaBens: [
        { nome: "numrSeqInclusao", titulo: "Item", tamanho: "5.rem" },
        { nome: "tipoBem.nomeApresentacao", titulo: "Cód. do Bem" },
        {
          nome: "flagTitularDependenteDesc",
          titulo: "Proprietário",
          tamanho: "8.rem",
        },
        {
          nome: "valrAquisicao",
          titulo: "Valor Aquisição",
          displayFormat: "currency-pt-br",
          tamanho: "8.rem",
        },
        {
          nome: "valrVenal",
          titulo: "Valor Venal",
          displayFormat: "currency-pt-br",
          tamanho: "8.rem",
        },
        {
          nome: "dataInclusao",
          titulo: "Data de Inclusão do Bem",
          tamanho: "9.rem",
        },
      ],
      titular: [],
      dialogConfirmacao: false,
      dialogConfirmacaoExclusao: false,
      isEditando: false,
      idenContaAcesso: 0,
      formData: this.pFormData,
      QtdMaximoCaracteres: 2000,
      permiteExecutarAcao:
        this.pFormData.tipoDeclaracao != "NAO_INFORMADO" ||
        this.pFormData.bens.length > 0,
    };
  },
  methods: {
    //REQUISIÇÃO VERIFICA SE EXISTE DADOS DO ANO ANTERIOR
    verificaDadosExercicioAnterior() {
      this.$http
        .put(
          `${baseApiUrl}/pessoaexercicios/verificacao/${this.formData.idenPessoaExercicio}/${this.idenContaAcesso}`
        )
        .then((res) => {
          res.data;
          this.carregarDadosTabela();
        });
    },

    carregarDadosTabela() {
      this.$http
        .get(
          `${baseApiUrl}/bempessoas/resumo/${this.formData.idenPessoaExercicio}/ativo`
        )
        .then((res) => {
          this.tabelaBens = res.data.content;
        });
    },

    carregarDados() {
      this.tabelaBens = this.formData.bens.filter(
        (item) => item.statBemPessoa != "INATIVO"
      );
      this.tratarEscritaSemSeparacao();
      this.registro.idenPessoaExercicio = this.formData.idenPessoaExercicio;
      this.idenContaAcesso = this.$store.getters.getUser.contaAcesso.id;

      //REQUISIÇÃO DO TIPO BENS
      this.$http.get(`${baseApiUrl}/tipobens/status/ativo`).then((res) => {
        this.codigoBem = res.data;
      });
      //REQUISIÇÃO DO TIPO LOCALIDADE
      this.$http.get(`${baseApiUrl}/paises/all`).then((res) => {
        this.localizacao = res.data;
      });
      //REQUISIÇÃO DO TIPO DEPENDENTE
      this.$http
        .get(`${baseApiUrl}/tipodependentes/status/ativo`)
        .then((res) => {
          this.tipoDependencia = res.data;
        });

      if (this.tabelaBens.length == 0) {
        this.verificaDadosExercicioAnterior();
      }

      this.$emit("atualizaParmForm", { component: this });
      // this.tratarEscritaSemSeparacao();
    },

    editarDadosTabelaBens(elemento) {
      this.registro = { ...elemento };
      this.isEditando = true;
      // this.$refs.divButtons.firstChild.focus();
    },
    limparCampo() {
      this.isEditando = false;
      this.registro = getDeclaracaoBens();
    },
    keyupFn() {
      if (
        this.QtdMaximoCaracteres - this.registro.descDiscriminacao.length <
        0
      ) {
        this.registro.descDiscriminacao =
          this.registro.descDiscriminacao.substring(
            0,
            this.QtdMaximoCaracteres
          );
      }
    },
    tratarEscritaSemSeparacao() {
      const caracteresEspeciais = [",", ".", ";", ":", "!", "?"];

      this.tabelaBens = this.tabelaBens.map((item) => {
        for (let caracter of caracteresEspeciais) {
          let arrayString = item.tipoBem.nomeApresentacao.split(caracter);
          var newNomeApresentacao = "";

          arrayString.forEach(function (element, index, array) {
            newNomeApresentacao += `${element.trim()}${
              index < array.length - 1 ? caracter : ""
            } `;
          });

          item.tipoBem.nomeApresentacao = newNomeApresentacao.trim();
        }

        return item;
      });
    },

    voltar() {
      this.$router.push({
        name: "inicio",
      });
    },
  },
  mounted() {
    this.carregarDados();
  },
};
</script>

<style scoped>
#botaoADD,
#botaoFim {
  font-size: 1.5vw;
  width: 11vw;
}
.p-col-12,
x .p-col-4 {
  margin: auto;
}
.p-dropdown-item {
  word-wrap: break-word im !important;
}

.formulario-container {
  margin: auto auto;
}
.contador-caracteres {
  margin-top: 0.6rem;
}
</style>